import type { DrawStateClient } from '@svs/nova-poolbetting/schema/draw';
import type { SportinfoMatchState } from '@svs/nova-poolbetting/sportinfo/lib';

/**
 * Utility function to determine the appropriate route based on the client-side draw state or the sportinfo match state of a single event.
 *
 * @param matchState The client-side draw state, or the sportinfo match state for a single event
 * @returns The corresponding route based on the match state
 */
export function getSportInfoRouteFromDrawState(matchState?: DrawStateClient | SportinfoMatchState): string {
  switch (matchState) {
    case 'Live':
    case 'Ongoing':
      return '/handelser';
    case 'Finished':
      return '/statistik';
    default:
      return '';
  }
}
